import styled from "styled-components";

export const CardList = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const Card = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  color: var(--text-color);
`;
export const BackgroundOverlay = styled.div`
  position: absolute;
  inset: 0 0 0 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 29.77%, rgba(0, 0, 0, 0) 69.09%);
`;

export const CardTitleDiv = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  h6 {
    margin-top: 10px;
    max-width: 265px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const EventTypeList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  flex-wrap: wrap;
`;
export const EventType = styled.div`
  padding: 4px 10px;
  background-color: var(--bg-color);
  text-transform: uppercase;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const CardFooter = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 15px;
  min-width: 130px;
  background-color: var(--bg-color);
  
  .mid {
    color: var(--alserkal-primary-slate, #75848c);
  }
  > * {
    transition: color .3s ease-in-out;
  }

  h6 {
    max-width: 155px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const AnimatedCard = styled.div`
  width: fit-content;
  height: fit-content;
  background: var(--primary);
  padding: 0;
  border: none;
  > a > div {
    transition: all 0.3s;
    &:hover {
      transform: translate(-6px, -6px);
      > div:last-child *{
        color: var(--primary) !important;
      }
    }
  }
`;
